import React from 'react';
import { Link } from 'react-router-dom';
import { FooterProps } from '../../types';
import EmailSubscription from '../molecules/EmailSubscription';
import Button from '../atoms/Button';
import Icon from '../atoms/Icon';
import './Footer.css';

const Footer: React.FC<FooterProps> = ({ 
  onEmailSubmit,
  onFollowShop 
}) => {
  const footerLinks = [
    { text: 'Contact us', href: '/contact' },
    { text: 'TFR Policy', href: '/policy' },
    { text: 'FAQ', href: '/faq' }
  ];

  const adminLink = { text: 'Admin', href: '?admin=true' };

  const policyLinks = [
    { text: 'Privacy policy', href: '/privacy' },
    { text: 'Terms of service', href: '/policy' },
    { text: 'Cookie preferences', href: '/cookies' }
  ];

  // const paymentMethods = [
  //   'visa', 'mastercard', 'amex', 'discover', 'diners', 
  //   'shoppay', 'applepay', 'googlepay', 'paypal'
  // ];

  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Top Row - Links */}
        <div className="footer-top">
          <div className="footer-links">
            {footerLinks.map((link, index) => (
              link.href.startsWith('/') ? (
                <Link key={index} to={link.href} className="footer-link">
                  {link.text}
                </Link>
              ) : (
                <a key={index} href={link.href} className="footer-link">
                  {link.text}
                </a>
              )
            ))}
          </div>
        </div>

        {/* Middle Section - Subscription */}
        {/* <div className="footer-middle">
          <div className="footer-subscription">
            <EmailSubscription onSubmit={onEmailSubmit} />
            <Button 
              variant="purple" 
              size="medium"
              onClick={onFollowShop}
              className="follow-button"
            >
              <Icon type="heart" size="small" />
              Follow on shop
            </Button>
          </div>
        </div> */}

        {/* Bottom Row - Copyright and Policies */}
        <div className="footer-bottom">
          <div className="footer-copyright">
            <p>© 2023, The Frosting Room Powered by MintMarketing.</p>
          </div>
          
          <div className="footer-policies">
            {policyLinks.map((link, index) => (
              link.href.startsWith('/') ? (
                <Link key={index} to={link.href} className="footer-policy-link">
                  {link.text}
                </Link>
              ) : (
                <a key={index} href={link.href} className="footer-policy-link">
                  {link.text}
                </a>
              )
            ))}
            <a href={adminLink.href} className="footer-admin-link">
              {adminLink.text}
            </a>
          </div>
        </div>

        {/* Payment Methods */}
        {/* <div className="footer-payments">
          <div className="payment-methods">
            {paymentMethods.map((method, index) => (
              <div key={index} className="payment-method">
                <span className="payment-text">{method.toUpperCase()}</span>
              </div>
            ))}
          </div>
        </div> */}
      </div>
    </footer>
  );
};

export default Footer;
